import React from 'react';
import i18n from '../i18n';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (window.gtag) {
      window.gtag('event', 'exception', {
        description: String(error?.message || error),
        fatal: true,
      });
    }
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            padding: 24,
            fontFamily: 'Lato, Roboto, sans-serif',
            color: '#303e70',
            textAlign: 'center',
          }}
        >
          <h1 style={{ fontFamily: 'Playfair Display, serif', marginBottom: 8 }}>
            {i18n.t('error.title', { defaultValue: 'Something went wrong' })}
          </h1>
          <p style={{ marginBottom: 24, color: '#555' }}>
            {i18n.t('error.bodyPrefix', {
              defaultValue:
                'Please refresh the page. If the problem persists, contact us at ',
            })}
            <a href="mailto:orders@hawrat.com" style={{ color: '#303e70' }}>
              orders@hawrat.com
            </a>
            .
          </p>
          <button
            onClick={this.handleReload}
            style={{
              background: '#303e70',
              color: '#fff',
              border: 'none',
              padding: '12px 24px',
              borderRadius: 8,
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            {i18n.t('error.reload', { defaultValue: 'Reload page' })}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
